import React, { useState, useEffect } from 'react';
import { AdminSidebar } from './Dashboard';
import api from '../../services/api';

export default function AdminProduto() {
  const [produto, setProduto] = useState(null);
  const [form, setForm]       = useState({});
  const [msg, setMsg]         = useState('');

  useEffect(() => {
    api.get('/admin/produto').then(({ data }) => {
      setProduto(data);
      const bens = typeof data.beneficios === 'string' ? JSON.parse(data.beneficios) : data.beneficios || [];
      setForm({ ...data, beneficios: bens.join('\n') });
    }).catch(() => {});
  }, []);

  const upd = e => {
    const v = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setForm(f => ({ ...f, [e.target.name]: v }));
  };

  const salvar = async e => {
    e.preventDefault(); setMsg('');
    try {
      const payload = { ...form, beneficios: form.beneficios.split('\n').map(b=>b.trim()).filter(Boolean) };
      await api.patch(`/admin/produto/${produto.id}`, payload);
      setMsg('sucesso');
    } catch { setMsg('erro'); }
  };

  if (!produto) return <div className="admin-layout"><AdminSidebar /><div className="admin-content"><p className="carregando">Carregando…</p></div></div>;

  return (
    <div className="admin-layout">
      <AdminSidebar />
      <div className="admin-content">
        <div className="admin-header"><h1 className="admin-title">Produto — {produto.nome}</h1></div>

        {msg === 'sucesso' && <div className="alert alert-success" style={{ marginBottom:20 }}>Produto atualizado com sucesso.</div>}
        {msg === 'erro'    && <div className="alert alert-danger"  style={{ marginBottom:20 }}>Erro ao salvar. Tente novamente.</div>}

        <form onSubmit={salvar}>
          <div className="card" style={{ padding:'28px 32px', marginBottom:20 }}>
            <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:19, marginBottom:22, paddingBottom:14, borderBottom:'1px solid var(--border)' }}>Informações do produto</h3>
            <div className="form-group"><label>Nome do produto</label><input name="nome" value={form.nome||''} onChange={upd} /></div>
            <div className="form-group"><label>Chamada comercial</label><input name="chamada_comercial" value={form.chamada_comercial||''} onChange={upd} /></div>
            <div className="form-group"><label>Descrição</label><textarea name="descricao" value={form.descricao||''} onChange={upd} rows={4} /></div>
            <div className="form-row">
              <div className="form-group"><label>Preço (R$)</label><input name="preco" type="number" step="0.01" value={form.preco||''} onChange={upd} /></div>
              <div className="form-group" style={{ display:'flex', alignItems:'flex-end', paddingBottom:4 }}>
                <label className="checkbox-group"><input type="checkbox" name="preco_exibir" checked={!!form.preco_exibir} onChange={upd} /><span style={{ fontSize:14 }}>Exibir preço no site</span></label>
              </div>
            </div>
            <div className="form-group">
              <label>Benefícios (um por linha)</label>
              <textarea name="beneficios" value={form.beneficios||''} onChange={upd} rows={7} placeholder={"Ajuda na proteção da pintura\nRealça o brilho\nFacilita a limpeza"} />
            </div>
            <div className="form-group"><label>Como usar</label><textarea name="como_usar" value={form.como_usar||''} onChange={upd} rows={3} /></div>
            <div className="form-row">
              <div className="form-group"><label>WhatsApp de contato</label><input name="whatsapp_contato" value={form.whatsapp_contato||''} onChange={upd} /></div>
              <div className="form-group" style={{ display:'flex', alignItems:'flex-end', paddingBottom:4 }}>
                <label className="checkbox-group"><input type="checkbox" name="ativo" checked={!!form.ativo} onChange={upd} /><span style={{ fontSize:14 }}>Produto ativo</span></label>
              </div>
            </div>
          </div>
          <button type="submit" className="btn btn-primary">Salvar alterações</button>
        </form>
      </div>
    </div>
  );
}
